"use client"

import { BannerList } from "@lib/data/banner"
import Image from "next/image"
import Link from "next/link"
import "swiper/css"
import { Autoplay, Thumbs } from "swiper/modules"
import { Swiper, SwiperSlide } from "swiper/react"

export const SliderImage = ({ main_slider }: { main_slider: BannerList[] }) => {
  return (
    <Swiper
      className="h-full w-full bg-[#EDEDED]"
      slidesPerView={1}
      loop
      modules={[Autoplay, Thumbs]}
      autoplay={{
        delay: 8000,
        disableOnInteraction: false,
      }}
    >
      {main_slider.map((image, index) => {
        return (
          <SwiperSlide key={index}>
            <Link href={image.click_url ?? "#"}>
              <Image
                className="w-full h-full object-cover z-0"
                src={image.image_url}
                alt={image.image_url}
                width={1920}
                height={520}
                priority
                fetchPriority="high"
              />
            </Link>
          </SwiperSlide>
        )
      })}
    </Swiper>
  )
}
